import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {AuthenticationService} from '../services/auth/authentication.service';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {

	protected router = inject(Router);
	protected authService = inject(AuthenticationService);

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
		// A merely *present* token isn't a session: an expired one must send the user back to the
		// login form instead of letting the page render and fail on the first 401.
		return of(this.authService.hasValidSessionSnapshot()).pipe(map(isAuth => {
			if (isAuth) {
				return true;
			} else if (state.url && state.url !== '/') {
				// Keep the target URL (e.g. /mcp/consent?request_id=…) so the login flow can resume it
				return this.router.createUrlTree(['login'], {queryParams: {returnUrl: state.url}});
			} else {
				return this.router.createUrlTree(['login']);
			}
		}));
	}
}
